"use client"

import { AlertCircle, CheckCircle } from "lucide-react"
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "./toast"
import { useToast } from "./use-toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider duration={3000}>
      {toasts.map(({ id, title, description, action, variant, icon, ...props }) => {
        const Icon = variant === "destructive" ? AlertCircle : CheckCircle
        const iconColor =
          variant === "destructive" ? "text-white" : variant === "success" ? "text-green-500" : "text-gray-500"

        return (
          <Toast key={id} variant={variant} {...props} duration={3000}>
            {icon || <Icon className={`h-5 w-5 shrink-0 ${iconColor}`} />}
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
